<template>
    <div>
        <b-row>
            <b-col cols="12" lg="6">
                <app-date-time-picker
                    :withTime="false"
                    label="Fecha finalización"
                    v-model="theService.endDate"
                    :required="true"
                    :hasError="$v.theService.endDate.$error"
                    error-message="Debe especificar la fecha"
                    :max-date="moment().toDate()"
                />
            </b-col>
            <b-col cols="12" lg="6">
                <label
                    >Hora de finalización
                    <span class="field-required-mark">*</span></label
                >
                <b-form-input
                    id="type"
                    type="time"
                    @change="$v.theService.endHour.$touch()"
                    v-model="theService.endHour"
                ></b-form-input>
                <span class="field-error" v-if="$v.theService.endHour.$error">
                    Debe especificar la hora</span
                >
            </b-col>
            <b-col cols="12" class="mt-4">
                <b-alert show variant="info"
                    >Duración servicio: {{ serviceDuration }}
                    {{ serviceDuration === 1 ? 'hora' : 'horas' }}</b-alert
                >
            </b-col>
            <b-col cols="12" class="mt-4" v-if="serviceDuration > maxDuration">
                <b-alert show variant="warning">
                    <small>
                        El servicio tiene una duración mayor a
                        {{ maxDuration }} horas, confirme la fecha y hora exacta
                        de la finalización
                    </small>
                </b-alert>
            </b-col>
            <b-col cols="12" class="mt-4">
                <label for=""
                    >Firma del cliente<span class="field-required-mark"
                        >*</span
                    ></label
                >
                <app-vue-signature
                    id="signature"
                    width="100%"
                    height="100px"
                    ref="signaturePad"
                />
                <div class="pull-right">
                    <br />
                    <b-btn variant="secondary" size="sm" @click="undo"
                        >Borrar</b-btn
                    >
                </div>
            </b-col>
        </b-row>
    </div>
</template>
<script>
import VueSignature from 'vue-signature-pad'
import { required } from 'vuelidate/lib/validators'
import bodyguardRepository from '../../../../../repositories/bodyguard.repository'
import { mapGetters } from 'vuex'
export default {
    props: {
        service: {
            type: Object,
            required: true,
        },
        onFinish: {
            type: Function,
        },
    },
    components: {
        appVueSignature: VueSignature,
    },
    data() {
        return {
            theService: {
                firm: '',
                endDate: '',
                endHour: '',
                latitude: '',
                longitude: '',
            },
            maxDuration: 8,
        }
    },
    validations: {
        theService: {
            endDate: {
                required,
            },
            endHour: {
                required,
            },
        },
    },
    computed: {
        serviceDuration() {
            if (
                !this.service ||
                !this.theService.endDate ||
                !this.theService.endHour
            )
                return 0

            const endDate = moment(
                `${this.theService.endDate} ${this.theService.endHour}`
            )
            const startDate = moment(this.service.start_date)

            return Math.ceil(endDate.diff(startDate, 'minutes') / 60)
        },
    },
    methods: {
        finishService() {
            if (!this.service || !this.service.id) {
                toastr.error('No se ha seleccionado un servicio válido')
                return false
            }

            this.$v.$touch()
            if (this.$v.$invalid) {
                toastr.error(
                    'Debe diligenciar correctamente todos los campos obligatorios'
                )
                return false
            }

            // Validar que el servicio no este cerrado ya
            if (!!this.service.end_date)
                return toastr.error('El servicio se encuentra cerrado')

            // Validar que el servicio tenga al menos una duración minima
            if (this.serviceDuration < 1)
                return toastr.error(
                    'El servicio debe tener una duración de una hora o más'
                )

            const { data } = this.$refs.signaturePad.saveSignature()

            if (data) {
                this.theService.firm = data
            } else {
                this.theService.firm = ''
                toastr.error('El cliente debe firmar en el panel')
                return false
            }

            const formData = new FormData()

            const serviceId = this.service.id ? String(this.service.id) : null
            if (!serviceId) {
                toastr.error('El servicio no tiene un ID válido')
                return false
            }

            formData.append('serviceId', serviceId)
            formData.append('endDate', this.theService.endDate)
            formData.append('endHour', this.theService.endHour)
            formData.append('latitude', this.theService.latitude)
            formData.append('longitude', this.theService.longitude)

            if (this.theService.firm) {
                formData.append('firm', this.theService.firm)
            }

            const br = {
                ...bodyguardRepository,
            }
            br.finishBodyguardService(formData)
                .then(({ data }) => {
                    if (data.status) {
                        toastr.success(data.msg)
                        typeof this.onFinish === 'function' && this.onFinish()
                    } else {
                        toastr.error(data.msg)
                    }
                })
                .catch(error => {
                    toastr.error('Error al finalizar el servicio')
                })
        },
        cleanForm() {
            this.setAutoDateTime()
            !!this.$refs.signaturePad &&
                this.$refs.signaturePad.clearSignature()
            this.$v.$reset()
        },
        undo() {
            this.$refs.signaturePad.undoSignature()
        },
        resizeSignaturePad() {
            this.$nextTick(function() {
                !!this.$refs.signaturePad &&
                    this.$refs.signaturePad.resizeCanvas()
            })
        },
        setAutoDateTime() {
            this.theService.endDate = moment().format('YYYY-MM-DD')
            this.theService.endHour = moment().format('HH:mm')
        },
        getCoords() {
            // obtener coordenadas de posicionamiento
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(position => {
                    this.theService.latitude = position.coords.latitude + ''
                    this.theService.longitude = position.coords.longitude + ''
                })
            }
        },
    },
    created() {
        this.$bus.$on('finish-service-form.save', this.finishService)
        this.$bus.$on('finish-service-form.clean', this.cleanForm)
        this.$bus.$on(
            'bodyguard-service-signature-pad.rezize',
            this.resizeSignaturePad
        )
    },
    beforeDestroy() {
        this.$bus.$off('finish-service-form.save')
    },
    mounted() {
        this.setAutoDateTime()
        this.getCoords()
    },
}
</script>

<style>
#signature {
    border: double 3px transparent;
    border-radius: 5px;
    background-image: linear-gradient(white, white),
        radial-gradient(circle at top left, #4bc5e8, #9f6274);
    background-origin: border-box;
    background-clip: content-box, border-box;
}
</style>
